module.exports = __webpack_public_path__ + "media/images/swifticons/influence-7d4f359ce6c73e85e6cf378aa31f51aa.svg";